import React from "react";
import Icon from "../../dashboard/Icon/Icon";
import { calculateProgress } from "../../utils/helper";
import "./progressBar.css";
import ThresholdBG from "./ThresholdsBG/ThresholdBG";
import Title from "../ReusableComponents/Title/Title";

const ProgressBarPreview = ({ configData = {} }) => {
  const thresholds =
    configData?.config?.setThresholds && configData?.config?.thresholds;
  const { config } = configData;
  const { color, width } = calculateProgress(configData);
  return (
    <div className="progress-bar-preview">
      <div className="icon-container">
        <Icon
          src={`images/${config?.icon?.imgName || "lsq_copy"}.svg`}
          alt="icon"
          className="icon"
        />
      </div>
      <div className="info-container">
        <Title text={config?.name}/>
        {config?.count > -1 && (
          <span className="count-container">
            <span className="ng_h_5_b">{config?.count}</span>
            <span className="max-count ng_p_1_m">
              {config?.maxCount ? `/${config.maxCount}` : ""}
            </span>
          </span>
        )}
      </div>
      <div className="progress-containers">
        <ThresholdBG thresholds={thresholds} />
        <div
          role="progressbar"
          style={{
            width: `${width}%`,
            backgroundColor: color,
          }}
        />
      </div>
    </div>
  );
};

export default ProgressBarPreview;
